import axios from "axios"; // 引入axios
import { bxzsURL } from "./url";
import router from "../router";
import store from "../store/index";

const baseURL = bxzsURL; //测试服务器

import { Message } from "element-ui";
const service = axios.create({
  baseURL: baseURL,
  timeout: 99999
});

service.interceptors.request.use(
  config => {
    config.headers = {
      "Content-Type": "application/json",
      authToken: "7810e284-a1ff-4d47-a47c-20024a671566",
      appId: "44c2b961-3f99-4162-912b-cbbf1eff0d63",

      ...config.headers
    };

    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// http response 拦截器
service.interceptors.response.use(
  response => {
    // 下载文件处理文件名
    if (response.headers["content-disposition"]) {
      response.data.fileName = decodeURIComponent(
        response.headers["content-disposition"].split("=")[1]
      );
    }
    if (response.data.status == "A0230") {
      Message.error(i18n.t("request.ban"));

      router.replace({
        path: "/login"
      });
    }
    if (response.data.status == 0) {
      // console.log(response.data,'------respond.data')
      return response.data;
    } else {
      if (response.message) {
        alert(response.data.message);
      }

      return response.data;
    }
  },
  error => {
    switch (error.response && error.response.status) {
      case 500:
        if (error.response.data.status == "A0001") {
          if (error.response.data.message == "此账号已被禁止访问服务：login") {
            Message.error(i18n.t("request.baned"));
          } else {
            Message.error(error.response.data.message);
          }
          // return
        } else {
          Message.error(i18n.t("request.systemError"));
          // return
        }
        // console.log('500')
        break;
      case 404:
        console.log("404");
        break;
    }
    store.state.isLoading = false;
    return Promise.reject(error);
  }
);
export default service;
